import CreateAccountFormState from "@iewcasia/Store/State/CreateAccount/CreateAccountFormState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: CreateAccountFormState = {
    fieldValues: {},
};

const reducer = {
    "Components/CreateAccountForm/ClearForm": (draft: Draft<CreateAccountFormState>) => {
        draft.fieldValues = {};
        draft.file = undefined;
    },
    "Components/CreateAccountForm/SetFieldValue": (
        draft: Draft<CreateAccountFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
    "Components/CreateAccountForm/SetFileValue": (
        draft: Draft<CreateAccountFormState>,
        action: File | string,
    ) => {
        const value = (action as any).value;
        if (!value || value === "") {
            draft.file = undefined;
        } else {
            draft.file = action as File;
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
